import { render } from "./PortfolioPage.vue?vue&type=template&id=396c9632&ts=true"
import script from "./PortfolioPage.vue?vue&type=script&lang=ts"
export * from "./PortfolioPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__